import { Twitter, Instagram, Linkedin, Facebook } from "lucide-react";

const NAV = [
  { label: "How It Works", href: "#how-it-works", testid: "footer-link-how-it-works" },
  { label: "Services", href: "#services", testid: "footer-link-services" },
  { label: "Become a Tasker", href: "#become-a-tasker", testid: "footer-link-become-tasker" },
  { label: "Safety", href: "#safety", testid: "footer-link-safety" },
  { label: "Help", href: "#help", testid: "footer-link-help" },
  { label: "London", href: "/london", testid: "footer-link-london" },
  { label: "Contact", href: "#app", testid: "footer-link-contact" },
];

const LEGAL = [
  { label: "Terms & Conditions", href: "/terms", testid: "footer-link-terms" },
  { label: "Privacy Policy", href: "/privacy", testid: "footer-link-privacy" },
  { label: "Cookie Policy", href: "/cookies", testid: "footer-link-cookies" },
  { label: "Complaints", href: "/complaints", testid: "footer-link-complaints" },
];

const SOCIALS = [
  { icon: Twitter, label: "Twitter", testid: "footer-social-twitter" },
  { icon: Instagram, label: "Instagram", testid: "footer-social-instagram" },
  { icon: Linkedin, label: "LinkedIn", testid: "footer-social-linkedin" },
  { icon: Facebook, label: "Facebook", testid: "footer-social-facebook" },
];

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="bg-navy text-slate-300">
      <div className="max-w-7xl mx-auto px-5 sm:px-8 py-16 md:py-20">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12">
          <div className="md:col-span-5">
            <a href="#top" data-testid="footer-logo" className="flex items-center">
              <img src="/brand/logo-full-white.png" alt="Your Helper" className="h-9 w-auto" />
            </a>
            <p className="mt-5 text-sm text-slate-400 leading-relaxed max-w-sm">
              A marketplace connecting people with trusted local service providers.
            </p>
            <div className="mt-6 flex gap-3">
              {SOCIALS.map((s) => (
                <a
                  key={s.label}
                  href="#top"
                  aria-label={s.label}
                  data-testid={s.testid}
                  className="w-10 h-10 rounded-full bg-white/[0.06] border border-white/10 grid place-items-center hover:bg-teal hover:border-teal transition-colors duration-200"
                >
                  <s.icon className="w-4 h-4" />
                </a>
              ))}
            </div>
          </div>

          <div className="md:col-span-3">
            <h3 className="font-mono text-xs uppercase tracking-[0.2em] text-slate-500">Explore</h3>
            <ul className="mt-5 space-y-3">
              {NAV.map((l) => (
                <li key={l.label}>
                  <a
                    href={l.href}
                    data-testid={l.testid}
                    className="text-sm hover:text-teal-light transition-colors duration-200"
                  >
                    {l.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-4">
            <h3 className="font-mono text-xs uppercase tracking-[0.2em] text-slate-500">Legal</h3>
            <ul className="mt-5 space-y-3">
              {LEGAL.map((l) => (
                <li key={l.label}>
                  <a
                    href={l.href}
                    data-testid={l.testid}
                    className="text-sm hover:text-teal-light transition-colors duration-200"
                  >
                    {l.label}
                  </a>
                </li>
              ))}
            </ul>
            <p className="mt-8 text-sm text-slate-500">
              Contact: <span className="text-slate-300">hello@yourhelper.uk</span>
            </p>
          </div>
        </div>

        <div className="mt-14 pt-8 border-t border-white/10 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-slate-500" data-testid="footer-copyright">
            © 2026 Your Helper. All rights reserved.
          </p>
          <p className="text-xs text-slate-600">Made in the UK</p>
        </div>
      </div>
    </footer>
  );
}
